import "./polyfill/index.js";
import "picturefill";
import renderPrimaryNav from "./components/GlobalHeader/renderPrimaryNav.jsx";
import renderMobileMenu from "./components/GlobalHeader/renderMobileMenu.jsx";
import initCarousels from "./components/Carousel/initCarousels.js";
import renderBackToTop from "./components/BackToTop/renderBackToTop.jsx";
import renderExploreTopicsTab from "./components/ExploreTopics/renderExploreTopics.jsx";
import renderNarrativeSubmenu from "./components/NarrativeSubmenu/renderNarrativeSubmenu.jsx";
import renderResources from "./components/Resources/renderResources.jsx";
import renderExperts from "./components/Experts/renderExperts.jsx";
import renderVisualizationFinder from "./components/VisualizationFinder/renderVisualizationFinder.jsx";
import renderNarrativeHeaderCharts from "./components/NarrativeHeaderChart/renderNarrativeHeaderCharts.jsx";
import renderNarrativeBodyCharts from "./components/NarrativeBodyChart/renderNarrativeBodyCharts.jsx";
import renderTopicFeatureMaps from "./components/TopicFeatureMap/renderTopicFeatureMaps.jsx";
import renderHomepageMaps from "./components/HomepageMap/renderHomepageMaps.jsx";
import initJumpLinks from "./common/initJumpLinks.js";
import renderMilestoneCharts from "./components/MilestoneChart/renderMilestoneCharts.jsx";
import renderLoginButton from "./components/LoginButton/renderLoginButton.jsx";
import renderReportBuilder from "./components/ReportBuilder/renderReportBuilder.jsx";
import { handleAnchoredUrl } from "./common/handleAnchoredUrl.js";
import renderModalLink from "./components/ModalLink/renderModalLink.jsx";
import renderTooltips from "./components/Tooltip/renderTooltips.jsx";
import renderStuntDrivers from "./components/StuntDrivers/renderStuntDrivers.jsx";
import renderAnnotations from "./components/Annotation/renderAnnotations.jsx";
import renderGlobalModals from "./components/GlobalModal/renderGlobalModals.jsx";
import renderPerspectivesThread from "./components/PerspectivesThread/renderPerspectivesThread.jsx";
import renderSitewideAlerts from "./components/GlobalHeader/SitewideAlert/renderSitewideAlert.jsx";
import CookieBanner from "./components/CookieBanner/cookieBanner.js";
import addPdfLinkHandlers from "./common/pdfLinkHandler.js";
import VideoPlayer from "../../Common/js/common/videoFlowplayer.js";
import renderShareIcons from "../../Common/js/components/ShareIcons/renderShareIcons.jsx";
import renderStoryListings from "./components/StoryListing/renderStoryListings.jsx";
import addCaseStudiesHandlers from "./common/caseStudies.js";

// Thread dependencies
import initEGHThreadSearch from "./thread/initEGHThreadSearch.js";
import Forms from "./thread/forms/forms.js";
import { ProfileControl } from "./thread/ProfileControl.js";
import { InterestsGroups } from "./thread/forms/InterestsGroups.js";
import createStore from "./common/createStore.js";
import fetchReportBuilderData from "./components/ReportBuilder/fetchReportBuilderData.js";
import initGlobalHealthLink from "./components/GlobalHealthResearch/initGlobalHealthLink.js";

import { initAccordions } from "./components/Accordion/initAccordion.js";

import accountNavigationHandler from "./common/accountNavigationHandler.js";

import "../../Common/js/common/appInsights.js";
import renderReferenceLinks from "./components/References/RenderReferenceLinks.jsx";
import renderDynamicContentListing from "./components/SearchModules/DynamicContentListing/renderDynamicContentListing.jsx";

import initFeaturedContent from "./components/FeaturedContent/initFeatureContent.js";

document.addEventListener("DOMContentLoaded", () => {
  fetchReportBuilderData().then((draftReport) => {
    const draftReportStore = createStore({ draftReport, siteAlertSet: false });

    //these components depend on the reportbuilder store to properly control the badge icon in the global header
    renderReportBuilder(draftReportStore);
    renderPrimaryNav(draftReportStore);
    renderSitewideAlerts(draftReportStore);
    renderMobileMenu(draftReportStore);
    renderNarrativeSubmenu(draftReportStore);
  });

  /**
   * Header
   * Primary nav and submenu moved to fetchReportBuilder function above to accomodate global store
   */
  renderLoginButton();

  /**
   * Account Navigation
   */
  accountNavigationHandler();

  /**
   * Experts
   */
  renderExperts();

  /**
   * Back to top button
   */
  renderBackToTop();

  /**
   * Carousels - owl carousel, jquery
   */
  initCarousels();

  /**
   * Resources
   */
  renderResources();

  /**
   * Visualization Finder
   */
  renderVisualizationFinder();

  /**
   * Accordion
   */
  initAccordions();

  /**
   * Annotation
   */
  renderAnnotations();

  /**
   * Charts
   */
  renderNarrativeHeaderCharts();
  renderNarrativeBodyCharts();
  renderMilestoneCharts();
  renderTopicFeatureMaps();
  renderHomepageMaps();

  /**
   * Explore Topic Tabs
   */
  renderExploreTopicsTab();

  /**
   * Modal Buttons
   */
  renderModalLink();

  /**
   * Tooltips
   */
  renderTooltips();
  renderReferenceLinks();

  /**
   * Perspective Thread Page
   */
  renderPerspectivesThread();

  /**
   * Global Modal Content
   */
  renderGlobalModals();

  /**
   * Stunt Drivers
   */
  renderStuntDrivers();

  /**
   * Thread Search App
   */
  initEGHThreadSearch();

  /**
   * Cookie banner
   */
  CookieBanner();

  addPdfLinkHandlers();

  // VideoPlayer
  VideoPlayer(document, window);

  // ShareIcons
  renderShareIcons();

  // StoryListings
  renderStoryListings();

  // Case Studies
  addCaseStudiesHandlers();

  /**
   * Init jump links for scroll behavior
   */
  initJumpLinks();

  /**
   * Initialize Dynamic Content Listing
   */
  renderDynamicContentListing();

  /**
   * Init Global Health Research Link to forward search params
   */
  initGlobalHealthLink();

  /**
   * Init Featured Content Card Turncate logic on subtitle fields
   */
  initFeaturedContent();
});

window.addEventListener("load", () => {
  /**
   * handle external hash links
   */
  setTimeout(() => handleAnchoredUrl(window.location.hash), 0);

  // handle interest group select all
  if (document.querySelector(".js-interests-form")) {
    new InterestsGroups(document.querySelector(".js-interests-form"));
  }

  if (document.querySelector(".js-profile")) {
    new ProfileControl(document.querySelector(".js-profile"));
  }

  if (document.querySelector(".js-form, .js-profile-form")) {
    Forms(document, window);
  }
});
